// extracted by mini-css-extract-plugin
export var inputContainer = "_sn-0";